import { DateTime } from 'luxon';
import DeploymentWeeks from '../models/organization/deployment-week';

export interface AggregatedOrganizationStatsData {
  totalOperatingTime: number;
  totalCleanedArea: number;
  chartData: {
    week: string;
    cleanedArea: number;
    duration: number;
    cleaningPerformance: number;
  }[];
}

export enum CostColors {
  CleaningCost = '#063b5f',
  ServiceCost = '#0c65a9',
  DailyMaintenance = '#118ff3',
}

export const getAggregatedData = (
  deploymentWeeks: DeploymentWeeks[] | null,
  deploymentFilter?: (d: DeploymentWeeks) => boolean,
): AggregatedOrganizationStatsData | null => {
  if (deploymentWeeks == null) {
    return null;
  }

  const filteredData = deploymentWeeks.filter(deploymentFilter ?? ((_) => true));
  const weekCleanedAreaAggregation: { [key: string]: number } = {};
  const weekCleaningDurationAggregation: { [key: string]: number } = {};
  const weekSavingsAggregation: { [key: string]: number } = {};
  let totalCleanedArea = 0;
  let totalOperatingTime = 0;

  for (let i = 0; i < 4; i++) {
    const weekStart = DateTime.now().startOf('week').minus({ weeks: i }).toString();
    weekSavingsAggregation[weekStart] = 0;
    weekCleanedAreaAggregation[weekStart] = 0;
    weekCleaningDurationAggregation[weekStart] = 0;
  }

  filteredData.forEach((deployment) => {
    deployment.weeks.forEach((week) => {
      const weekStart = DateTime.fromJSDate(new Date(week.startDate)).startOf('week').toString();
      if (!weekCleanedAreaAggregation[weekStart]) {
        weekCleanedAreaAggregation[weekStart] = 0;
      }
      if (!weekCleaningDurationAggregation[weekStart]) {
        weekCleaningDurationAggregation[weekStart] = 0;
      }
      if (!weekSavingsAggregation[weekStart]) {
        weekSavingsAggregation[weekStart] = 0;
      }
      weekCleanedAreaAggregation[weekStart] += week.cleanedArea;
      weekCleaningDurationAggregation[weekStart] += week.duration;
      totalCleanedArea += week.cleanedArea;
      totalOperatingTime += week.duration;
    });
  });

  return {
    totalOperatingTime,
    totalCleanedArea,
    chartData: Object.keys(weekCleanedAreaAggregation)
      .sort()
      .map((weekStart) => {
        const duration = weekCleaningDurationAggregation[weekStart] / 3600;
        return {
          week: weekStart,
          cleanedArea: weekCleanedAreaAggregation[weekStart],
          duration,
          cleaningPerformance:
            duration === 0 ? 0 : weekCleanedAreaAggregation[weekStart] / duration,
        };
      }),
  };
};
